import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@homeleite/arch';
import { AdminGuard } from '../../core/guards/admin.guard';
import { IntegrationSettingsComponent } from './integration-settings.component';

const routes: Routes = [
    {
        path: 'integration-settings',
        component: IntegrationSettingsComponent,
        canActivate: [AuthGuard, AdminGuard],
        data: { title: 'Home Leite - Integração SRG-SCL' }
    }
];

export const IntegrationSettingsRoutes = RouterModule.forChild(routes);
